










import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";

import MyConfig from "@/config";

@Component({
  components: {
    "tinymce-editor": Editor
  }
})
export default class extends Mixins() {
  @Prop() value!: string;

  @Prop({ default: 300 }) height!: number;

  @Prop() callback!: (...args: any[]) => any;

  disabled = false;

  apiserver: string = MyConfig.casapi;

  editorData = "";

  editorData1 = "";

  editorId = "";

  editorVisible = false;

  editorInit: any = {
    language: "zh_CN",
    fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px",
    plugins:
      "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
    imagetools_cors_hosts: ["picsum.photos"],
    menubar: "file edit view insert format tools table help",
    toolbar:
      "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",
    image_advtab: true,
    automatic_uploads: true,
    importcss_append: true,
    // images_upload_url: `${
    //   this.apiserver
    // }cos/cke-upload?authorization=${window.localStorage.getItem("token")}`,
    images_upload_handler: (blobInfo: any, succFun: any, failFun: any) => {
      this.uploadFile(blobInfo, succFun, failFun);
    },
    height: this.height,
    image_caption: true,
    quickbars_selection_toolbar: "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
    noneditable_noneditable_class: "mceNonEditable",
    toolbar_mode: "sliding",
    contextmenu: "link image imagetools table"
  };

  @Watch("value")
  watchValue(val: any, oldval: any) {
    // console.log(val);
    // console.log(oldval);
    this.editorData1 = val;
  }

  uploadFile(blobInfo: any, succFun: any, failFun: any) {
    const file: any = blobInfo.blob();
    const xhr: any = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open(
      "POST",
      `${this.apiserver}cos/cke-upload?authorization=${window.localStorage.getItem("token")}`
    );

    xhr.onload = () => {
      // let json;
      if (xhr.status != 200) {
        if (failFun) {
          failFun(`HTTP Error: ${xhr.status}`);
        }
        return;
      }
      const json = JSON.parse(xhr.responseText);
      // console.log(json);
      if (!json || typeof json.url != "string") {
        if (failFun) {
          failFun(`Invalid JSON: ${xhr.responseText}`);
        }
        return;
      }
      if (succFun) {
        succFun(json.url);
      }
    };

    const formData: any = new FormData();
    formData.append("upload", file, file.name);
    xhr.send(formData);
  }

  mounted() {
    // console.log(this.value);
    this.editorData1 = this.value;
    this.editorVisible = true;
  }

  handleChange(e: any, editor: any) {
    this.editorData1 = editor.getContent();
    this.$emit("change", this.editorData1);
  }
}
